// src/data/coins.js
export const coins = [
  {
    id: 1,
    name: "Saint-Gaudens Double Eagle",
    year: "1907",
    grade: "MS65",
    gradeNum: 65,
    price: "$42,000",
    priceNum: 42000,
    image: "/assets/images/Saint-Gaudens Double Eagle.jpg",
    category: "gold",
    metal: "Gold",
    inStock: true,
    isNew: false,
    views: 1250,
    description: "One of the most beautiful US coins ever designed, featuring Lady Liberty with a torch."
  },
  {
    id: 2,
    name: "Liberty Head Gold Coin",
    year: "1854",
    grade: "AU58",
    gradeNum: 58,
    price: "$3,200",
    priceNum: 3200,
    image: "/assets/images/Liberty Head Gold Coin.jpg",
    category: "gold",
    metal: "Gold",
    inStock: true,
    isNew: true,
    views: 980,
    description: "Classic Liberty Head design from the California Gold Rush era."
  },
  {
    id: 3,
    name: "Indian Head Eagle",
    year: "1910",
    grade: "MS63",
    gradeNum: 63,
    price: "$12,500",
    priceNum: 12500,
    image: "/assets/images/Indian Head Eagle.jpg",
    category: "gold",
    metal: "Gold",
    inStock: true,
    isNew: false,
    views: 2100,
    description: "Stunning Indian Head design with intricate feather details."
  },
  {
    id: 4,
    name: "Ancient Roman Coin",
    year: "114 AD",
    grade: "XF40",
    gradeNum: 40,
    price: "$950",
    priceNum: 950,
    image: "/assets/images/ancient roman coin.jpg",
    category: "ancient",
    metal: "Silver",
    inStock: true,
    isNew: true,
    views: 850,
    description: "Authentic Roman denarius from the reign of Trajan, featuring exceptional detail."
  },
  {
    id: 5,
    name: "Gold Sovereign",
    year: "1911",
    grade: "MS62",
    gradeNum: 62,
    price: "$1,250",
    priceNum: 1250,
    image: "/assets/images/Gold soverein.webp",
    category: "modern",
    metal: "Gold",
    inStock: true,
    isNew: false,
    views: 650,
    description: "British gold sovereign featuring St. George and the dragon."
  },
  {
    id: 6,
    name: "Silver Eagle",
    year: "2023",
    grade: "MS69",
    gradeNum: 69,
    price: "$95",
    priceNum: 95,
    image: "/assets/images/silver eagle.jpg",
    category: "modern",
    metal: "Silver",
    inStock: true,
    isNew: true,
    views: 450,
    description: "Modern American Silver Eagle with stunning proof-like finish."
  },
];